import { render, staticRenderFns } from "./TireReferenceModelCreateOrUpdate.vue?vue&type=template&id=1c9c7392&"
import script from "./TireReferenceModelCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TireReferenceModelCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports